var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessenger({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.7377 16.9405C-1.00984 9.94494 4.06508 1.48169 12.0015 1.49244C23.5676 1.50811 26.0793 16.6259 16.8105 21.4031C13.7814 22.881 10.0275 22.8561 7.05559 21.2662L6.04197 21.5375L2.52315 22.4798C2.38457 22.5169 2.23866 22.5169 2.10008 22.4797C1.9615 22.4426 1.83513 22.3697 1.73366 22.2682C1.63218 22.1668 1.55919 22.0405 1.52199 21.9019C1.4848 21.7634 1.48471 21.6174 1.52175 21.4788L2.46402 17.959L2.7377 16.9405Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5619 11.8568L10.303 8.5985L5.66406 15.4025L10.4423 12.1442L13.7007 15.4025L18.3396 8.5985L13.5619 11.8568Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessenger);
export default __webpack_public_path__ + "static/media/messenger.b39dd935405b7b203e8ddde26c4322a6.svg";
export { ForwardRef as ReactComponent };